// extracted by mini-css-extract-plugin
module.exports = {"track":"styles_track__OUxzA","swipe":"styles_swipe__Mbgzu","copy":"styles_copy__lbAwm"};